<template>
  <w-flex class="column align-center">
      <!--<Splash/>
      <div class="break"></div>-->
    <suspense>
      <template #default>
        <InitiativeCards :user="user"/>
      </template>
      <template #fallback>
        <Loading/>
      </template>
    </suspense>
  </w-flex>
</template>

<script>
import InitiativeCards from '../components/InitiativeCards.vue'
import Loading from '../components/Loading.vue'
//import Splash from '../components/Splash.vue'


export default {
  name: 'Home',
  components: {
    //Splash,
    InitiativeCards,
    Loading
  },
  props: {
    user: Object
  }
}
</script>

<style>
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans"),
   url(../fonts/OpenSans/OpenSans-Regular.ttf) format("truetype");
}

.w-app{
  font-family: "Open Sans";
}

.break {
  flex-basis: 100%;
  height: 0;
}
</style>
